import {SegmentedControl} from '@dropbox/dig-components/controls';

const getQuarterYear = (quarter: string): string | null =>
  quarter.trim().match(/^(\d{4})[\s-]?q[1-4]$/i)?.[1] ?? null;

const getQuarterLabel = (quarter: string): string => {
  const match = quarter.trim().match(/q([1-4])$/i);
  return match ? `Q${match[1]}` : quarter;
};

export const RoadmapQuarterControl = ({
  availableQuarters,
  selectedQuarter,
  onSelect,
}: {
  availableQuarters: string[];
  selectedQuarter: string;
  onSelect: (quarter: string) => void;
}) => {
  const selectedYear = getQuarterYear(selectedQuarter);
  const visibleQuarters = selectedYear
    ? availableQuarters.filter((quarter) => getQuarterYear(quarter) === selectedYear)
    : availableQuarters;

  if (visibleQuarters.length === 0) {
    return null;
  }

  return (
    <SegmentedControl
      selectedValue={selectedQuarter}
      onSelection={(quarter) => onSelect(String(quarter))}
      aria-label={selectedYear ? `Quarter, ${selectedYear}` : 'Quarter'}
    >
      {visibleQuarters.map((quarter) => (
        <SegmentedControl.Option key={quarter} variant="text" value={quarter}>
          {getQuarterLabel(quarter)}
        </SegmentedControl.Option>
      ))}
    </SegmentedControl>
  );
};
